import React, { useState, useEffect } from "react";
import axios from "axios";

import { Row, Col, Table, Container, Spinner } from "react-bootstrap";
import Chart from "react-apexcharts";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ADMIN_DASHBOARD_API } from "../../../api/api";

// import totalViewsImg from "../../../assets/tutor-student-dou-icon1.png";
// import avgCompletionImg from "../../../assets/tutor-student-dou-icon1.png";
// import totalstudentImg from "../../../assets/tutor-student-dou-icon1.png";
// import AvgRatingImg from "../../../assets/tutor-student-dou-icon1.png";
// import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

// latestIcons
import totalStudents from "../../../assets/icons/admin/enrolled-students.svg";
import activeTutors from "../../../assets/icons/admin/active-tutors.svg";
import activeCourses from "../../../assets/icons/student/course.svg";
import internshipRequests from "../../../assets/icons/admin/internship-requests.svg";

import Nofound from "../../../assets/not-found.png";

import { handleApiError } from "../../../utils/apiErrorHandler";

import "./AdminDashboard.css";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const [adminDashStats, setAdminDashStats] = useState({});
  const [chartData, setChartData] = useState({});
  const [recentSubmissions, setRecentSubmissions] = useState([]);

  //loading
  const [loadingAdminDash, setLoadingAdminDash] = useState(true);

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setLoadingAdminDash(false);
      navigate("/admin-signin");

      return;
    }

    const fetchAdminDashboard = async () => {
      try {
        const response = await axios.get(
          ADMIN_DASHBOARD_API.GET_ADMIN_DASHBOARD_STATS,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = response.data;

        if (data.statusCode === 200) {
          setAdminDashStats({
            total_students: Number(data.stats?.total_students || 0),
            active_tutors: Number(data.stats?.active_tutors || 0),
            active_courses: Number(data.stats?.active_courses || 0),
            internship_requests: Number(data.stats?.internship_requests || 0),
          });

          setChartData(data.charts || {});
          setRecentSubmissions(data.recent_submissions || []);
        } else {
          // This will handle any 2xx response that is not 201
          showErrorToast(data.message);
        }
      } catch (error) {
        console.error("Error dashboard:", error);
        // Server responded with non-2xx status (like 400, 500)

        // CHECK (expiry / invalid token)
        handleApiError(error, navigate, showErrorToast, "/admin-signin");
      } finally {
        setLoadingAdminDash(false);
      }
    };

    fetchAdminDashboard();
  }, [navigate]);

  // NAVIGATION LOGIC ADDED
  const handleRowClick = (item) => {
    if (!item?.type) return;

    const routeMap = {
      "Course Purchased": "/header/admin/student-payments",
      Internship: "/header/admin/internship",
      "Final Exam": "/header/admin/assignments",
    };

    // Registration needs role check
    if (item.type === "Registration") {
      if (item.role === "tutor") {
        navigate("/header/admin/all-tutor");
        return;
      }
      if (item.role === "student") {
        navigate("/header/admin/student-management");
        return;
      }
    }

    const path = routeMap[item.type];
    if (path) navigate(path);
  };

  const enrollmentCategories =
    chartData.studentGraph?.map((item) => item.month) || [];

  const enrollmentOptions = {
    chart: {
      // id: "revenue-trend",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: { width: 2.5, curve: "smooth" },
    colors: ["#2563eb"],
    xaxis: {
      categories: enrollmentCategories,
      labels: { style: { fontSize: "12px", colors: "#6b7280" } },
    },
    grid: { borderColor: "#e9ecef", strokeDashArray: 4 },
    markers: { size: 3, strokeWidth: 2, strokeColors: "#fff" },
    legend: {
      position: "bottom",
      fontSize: "12px",
      markers: { width: 8, height: 8, radius: 12 },
    },
  };

  const enrollmentSeries = [
    {
      name: "Students",
      data:
        chartData.studentGraph?.map(
          (item) => Number(item.student_count) || 0,
        ) || [],
    },
  ];

  const courseLabels =
    chartData.coursePopularity?.map((item) => item.course_title) || [];

  const courseOptions = {
    chart: {
      // id: "revenue-pie",
      toolbar: { show: false },
    },
    labels: courseLabels,

    // tooltip: {
    //   enabled: false,
    // },
  };

  const courseSeries =
    chartData.coursePopularity?.map(
      (item) => Number(item.total_students) || 0,
    ) || [];

  if (loadingAdminDash) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <Container className="admin-dashboard-section">
      <h4 className="admin-dashboard-title">Admin Dashboard</h4>
      <p className="admin-dashboard-subtitle">
        Monitor and manage the overall Skilledition platform activities. 
      </p>

      <Row className="admin-analytics-section-cards-row">
        <Col lg={3} md={4} sm={6} xs={12}>
          <div className="admin-analytics-section-stat-card">
            <h6 className="admin-analytics-section-stat-title">
              Enrolled Students
            </h6>
            <img
              src={totalStudents}
              className="admin-analytics-stat-icon"
              alt="students"
            />

            <h3 className="admin-analytics-section-stat-value">
              {adminDashStats.total_students || "-"}
            </h3>
            <span className="admin-analytics-section-stat-sub">
              +12% from last month
            </span>
          </div>
        </Col>

        <Col lg={3} md={4} sm={6} xs={12}>
          <div className="admin-analytics-section-stat-card">
            <h6 className="admin-analytics-section-stat-title">
              Active Tutors
            </h6>
            <img
              src={activeTutors}
              className="admin-analytics-stat-icon"
              alt="tutors"
            />

            <h3 className="admin-analytics-section-stat-value">
              {adminDashStats.active_tutors || "-"}
            </h3>
            <span className="admin-analytics-section-stat-sub">
              +3% vs last month
            </span>
          </div>
        </Col>

        <Col lg={3} md={4} sm={6} xs={12}>
          <div className="admin-analytics-section-stat-card">
            <h6 className="admin-analytics-section-stat-title">
              Active Courses
            </h6>
            <img
              src={activeCourses}
              className="admin-analytics-stat-icon"
              alt="course"
            />

            <h3 className="admin-analytics-section-stat-value">
              {adminDashStats.active_courses || "-"}
            </h3>
            <span className="tutor-analytics-section-stat-sub">
              +8% w/o churn
            </span>
          </div>
        </Col>

        <Col lg={3} md={4} sm={6} xs={12}>
          <div className="admin-analytics-section-stat-card">
            <h6 className="admin-analytics-section-stat-title">
              Total Pending Internships
            </h6>
            <img
              src={internshipRequests}
              className="admin-analytics-stat-icon"
              alt="requests"
            />

            <h3 className="admin-analytics-section-stat-value">
              {adminDashStats.internship_requests || "-"}
            </h3>
            <span className="admin-analytics-section-stat-sub">
              Based on 3,400 reviews
            </span>
          </div>
        </Col>
      </Row>

      <Row className="mt-5">
        {/*Enrollment Trend */}
        <Col md={6}>
          <div className="tutor-analytics-revenue-card p-3">
            <div className="tutor-analytics-revenue-title">
              Course Enrollment Trend
            </div>
            {(enrollmentSeries?.[0]?.data || []).some((value) => value > 0) ? (
              <Chart
                options={enrollmentOptions}
                series={enrollmentSeries}
                type="line"
                height={260}
              />
            ) : (
              <p className="admin-dashboard-no-data mt-5">
                No enrollment data available
              </p>
            )}
          </div>
        </Col>

        {/* Course Popularity  */}
        <Col md={6}>
          <div className="tutor-analytics-pie-card p-3">
            <div className="tutor-analytics-revenue-title mb-2">
              Course Popularity
            </div>
            {(courseSeries || []).some((value) => value > 0) ? (
              <Chart
                options={courseOptions}
                series={courseSeries}
                type="pie"
                height={260}
              />
            ) : (
              <p className="admin-dashboard-no-data mt-5">
                No course data available
              </p>
            )}
          </div>
        </Col>
      </Row>

      <div className="admin-dashboard-table-wrapper mt-5">
        <h5 className="admin-dashboard-table-wrapper-title">
          Recent Activities
        </h5>

        <div className="admin-dashboard-table-scroll">
          <Table className="admin-dashboard-table" borderless>
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Submitted</th>
              </tr>
            </thead>

            <tbody>
              {recentSubmissions.length > 0 ? (
                recentSubmissions.map((item, idx) => (
                  <tr
                    key={idx}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleRowClick(item)}
                  >
                    <td>{item.full_name || "-"}</td>
                    <td>
                      <span
                        className={`admin-dashboard-status ${item.type
                          ?.toLowerCase()
                          .replace(/\s+/g, "-")}`}
                      >
                        {item.type || "-"}
                      </span>
                    </td>
                    <td>{item.activity_date || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12" className="admin-all-tutor-empty-table">
                    <img
                      src={Nofound}
                      alt="No Data Found"
                      className="admin-all-tutor-empty-img"
                    />
                    <p className="admin-dashboard-no-data">No Data Found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </Container>
  );
};

export default AdminDashboard;
